var exports = {
  "W": "shared.module__subsectionTitle___S1FST0",
};

module.exports = exports;
